import React from 'react';

import Permissions from 'react-redux-permissions';
import { Route, RouteComponentProps, Switch, withRouter } from 'react-router';

import { store } from '../../helpers/store';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';
import { flagService } from '../../services/flagService/flagService';
import PreviewPage from '../WebsiteAndApp/components/PreviewPage';
import WebsiteDomainSetup from '../WebsiteAndApp/components/SetupDomain';
import CookieSettings from '../WebsiteAndApp/CookieSettings/CookieSettings';
import EditWebsiteSettings from '../WebsiteAndApp/Edit/EditWebsiteSettings';
import WebsiteSettings from '../WebsiteAndApp/WebSiteSettings/WebsiteSettings';
import AddChannel from './AddChannel/AddChannel';
import ChannelSettings from './ChannelSettings/ChannelSettings';
import { Android } from './MobileApps/pages/Android';
import { AppSubmission } from './MobileApps/pages/AppSubmission';
import { MobileApps } from './MobileApps/pages/MobileApps';
import SalesChannelsGeneralSettings from './Settings/SalesChannelsGeneralSettings';
import StoreMapping from './StoreMapping/StoreMapping';
import StoreVisibilityPage from './Website/StoreVisibilityPage';
import SalesChannels from './Website/WebsiteSettings';

type Props = RouteComponentProps;

const SalesChannelsRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  const addChannelFlag = flagService.isFlagOn(store.getState(), 'addChannel');
  const mobileAppsFlag = flagService.isFlagOn(store.getState(), 'mobileApps');

  return (
    <ErrorBoundary identifier="sales-channels">
      <Switch>
        {mobileAppsFlag && <Route exact path={`${path}/mobile-apps/android`} component={Android} />}
        <Permissions allowed={['ViewSalesChannels', 'EditSalesChannels']}>
          <Route exact path={`${path}/general-settings`} component={SalesChannelsGeneralSettings} />

          <Route exact path={`${path}/mobile-apps`} component={MobileApps} />

          {mobileAppsFlag && (
            <Route exact path={`${path}/mobile-apps/app-submission`} component={AppSubmission} />
          )}
          <Route path={`${path}/website-settings`} component={SalesChannels} />

          <Route exact path={`${path}/website/live-editor`} component={EditWebsiteSettings} />
          <Route exact path={`${path}/website/preview`} component={PreviewPage} />
          <Route exact path={`${path}/website/analytics-and-social`} component={WebsiteSettings} />
          <Route exact path={`${path}/website/domain-setup`} component={WebsiteDomainSetup} />
          <Route exact path={`${path}/website/cookie-management`} component={CookieSettings} />
          <Route exact path={`${path}/website/store-visibility`} component={StoreVisibilityPage} />

          {addChannelFlag && <Route exact path={`${path}/add-channel`} component={AddChannel} />}

          {addChannelFlag && <Route exact path={`${path}/:channel`} component={ChannelSettings} />}
          {addChannelFlag && (
            <Route exact path={`${path}/:channel/store-mapping`} component={StoreMapping} />
          )}
        </Permissions>
      </Switch>
    </ErrorBoundary>
  );
};

export default withRouter(SalesChannelsRoutes);
